export enum ReceiptAlertType {
    Information = 'INFO',
    Warning = 'WARN',
    Danger = 'DANGER',
}

const translationObject: { [Key in ReceiptAlertType]: string } = {
    [ReceiptAlertType.Information]: 'app.enum.receiptAlertType.INFO',
    [ReceiptAlertType.Warning]: 'app.enum.receiptAlertType.WARN',
    [ReceiptAlertType.Danger]: 'app.enum.receiptAlertType.DANGER',
};

const translationFilterObject: { [Key in ReceiptAlertType]: string } = {
    [ReceiptAlertType.Information]: 'app.enum.receiptAlertType.filter.INFO',
    [ReceiptAlertType.Warning]: 'app.enum.receiptAlertType.filter.WARN',
    [ReceiptAlertType.Danger]: 'app.enum.receiptAlertType.filter.DANGER',
};

export const getReceiptAlertTypeTranslationId = (alertType: ReceiptAlertType): string => {
    return translationObject[alertType];
};

export const getReceiptAlertTypeFilterTranslationId = (alertType: ReceiptAlertType): string => {
    return translationFilterObject[alertType];
};

export const getReceiptAlertColorCode = (alertType: ReceiptAlertType): 'primary' | 'warning' | 'error' => {
    switch (alertType) {
        case ReceiptAlertType.Information:
            return 'primary';
        case ReceiptAlertType.Warning:
            return 'warning';
        case ReceiptAlertType.Danger:
            return 'error';
        default:
            return 'primary';
    }
};
